import { useQuery } from '@apollo/client';
import { useCurrentAccount } from '@application/api';
import { graphql } from '@gql/gql';
import type { LitterGetBookmarkQuery, LitterGetBookmarkQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';

export const LITTER_GET_BOOKMARK = graphql(`
  query LitterGetBookmark($bookmarksWhere: BookmarkWhereInput, $bookmarksTake: Int) {
    accountMe {
      id
      bookmarks(where: $bookmarksWhere, take: $bookmarksTake) {
        id
      }
    }
  }
`);

export const useGetBookmark = (litterId?: number | null) => {
  const { currentAccountLoggedIn } = useCurrentAccount();

  const bookmarkVariables = useMemo((): LitterGetBookmarkQueryVariables => {
    return {
      bookmarksTake: 1,
      bookmarksWhere: {
        litterId: { equals: litterId },
      },
    };
  }, [litterId]);

  const { data, loading, error } = useQuery<
    LitterGetBookmarkQuery,
    LitterGetBookmarkQueryVariables
  >(LITTER_GET_BOOKMARK, {
    variables: bookmarkVariables,
    skip: !currentAccountLoggedIn,
    ssr: false,
  });

  return {
    hasBookmark: data?.accountMe?.bookmarks?.[0] != null,
    bookmarkLoading: loading,
    bookmarkError: error,
    bookmark: data?.accountMe?.bookmarks[0],
    bookmarkVariables,
  };
};
